(() => {
  const selector = [
    '.pf-flex-section',
    '.card',
    '.product__info-container',
    '.product__media-wrapper',
    '.rvo-native-footer__inner'
  ].join(',');

  const setGlare = (event) => {
    const target = event.target.closest(selector);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    target.style.setProperty('--rvo-glare-x', `${Math.max(0, Math.min(100, x)).toFixed(1)}%`);
    target.style.setProperty('--rvo-glare-y', `${Math.max(0, Math.min(100, y)).toFixed(1)}%`);
  };

  const resetGlare = (event) => {
    const target = event.target.closest(selector);
    if (!target) return;
    target.style.removeProperty('--rvo-glare-x');
    target.style.removeProperty('--rvo-glare-y');
  };

  document.addEventListener('pointermove', setGlare, { passive: true });
  document.addEventListener('pointerleave', resetGlare, true);


  const initParallax = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const heroTargets = Array.from(document.querySelectorAll('.__pf_Tcgdlzx- .pf-10_, .__pf_Tcgdlzx- .pf-15_'));
    const imageTargets = Array.from(document.querySelectorAll('.__pf_Tcgdlzx- .pf-36_, .__pf_Tcgdlzx- .pf-44_, .__pf_Tcgdlzx- .pf-69_'));
    const targets = [...heroTargets, ...imageTargets];
    if (!targets.length) return;

    heroTargets.forEach((el) => el.dataset.rvoParallax = 'hero');
    imageTargets.forEach((el) => el.dataset.rvoParallax = 'image');

    let ticking = false;
    const update = () => {
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      targets.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > viewport + 120) return;
        const centerDistance = (viewport / 2) - (rect.top + rect.height / 2);
        const amount = Math.max(-22, Math.min(22, centerDistance * 0.035));
        if (el.dataset.rvoParallax === 'hero') {
          el.style.setProperty('--rvo-bg-y', `${amount.toFixed(1)}px`);
        } else {
          el.style.setProperty('--rvo-parallax-y', `${amount.toFixed(1)}px`);
        }
      });
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax, { once: true });
  } else {
    initParallax();
  }

})();



// RVO real CTA button system: mark only actual storefront CTA buttons and track hover location.
(function () {
  const explicitSelector = [
    '.product-form__submit',
    'product-form .product-form__submit',
    '.shopify-payment-button__button',
    '.cart__checkout-button',
    '.contact__button button',
    '.customer button[type="submit"]',
    '.quick-add__submit',
    '.pf-button',
    '[data-pf-type="Button"]',
    '[data-pf-type="Button"] a',
    'a[href*="/collections/"]',
    'a[href*="/products/"]',
    'a[href*="/pages/contact"]',
    'a[href*="/pages/custom"]',
    'a[href*="/pages/dealer"]',
    'a[href*="/pages/dealers"]'
  ].join(',');

  const neverSelector = [
    '.skip-to-content-link',
    '[href="#ProductInfo-template--"]',
    '[href*="#ProductInfo"]',
    '.quantity__button',
    '.drawer__close',
    '.modal__close-button',
    '.search__button',
    '.search-modal__close-button',
    '.slider-button',
    '.share-button__button',
    '.disclosure__button',
    '.localization-form__select',
    '.header__icon',
    '.menu-drawer__close-button',
    '.thumbnail',
    '.facets__summary',
    '.pagination__item',
    'footer a',
    '.footer a',
    '.rvo-footer a',
    '.rvo-footer-static a',
    '[class*="footer"] a'
  ].join(',');

  const goodText = [
    'add to cart',
    'buy it now',
    'checkout',
    'check out',
    'contact us',
    'submit',
    'send',
    'shop now',
    'shop',
    'view collection',
    'classic collection',
    'modern collection',
    'collection',
    'learn more',
    'view product',
    'custom products',
    'dealer'
  ];

  function isRealCta(el) {
    if (!el || el.matches(neverSelector)) return false;
    if (el.closest('header, .header, .header-wrapper')) return false;
    if (el.closest('cart-drawer, cart-items, .cart-drawer, .cart-items, .cart-item, #main-cart-items, .cart__items')) return false;
    if (el.closest('.product-grid, .card-wrapper, .product-card-wrapper, .card__heading, .related-products, .template-search .card, .collection .card')) return false;
    if (el.closest('footer, .footer, .rvo-footer, .rvo-footer-static, [class*="footer"]')) return false;
    if (el.closest('.header-wrapper') && !el.matches('.pf-button, [data-pf-type="Button"]')) return false;
    if (el.closest('quantity-input') || el.closest('.quantity')) return false;

    const text = (el.textContent || el.value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const href = (el.getAttribute && el.getAttribute('href') || '').toLowerCase();
    const type = (el.getAttribute && el.getAttribute('type') || '').toLowerCase();

    if (el.matches('.product-form__submit, .shopify-payment-button__button, .cart__checkout-button, .contact__button button, .customer button[type="submit"], .quick-add__submit')) return true;
    if (type === 'submit' && !el.matches('.search__button, .newsletter-form__button')) return true;
    if (href.includes('/collections/') || href.includes('/products/') || href.includes('/pages/contact') || href.includes('/pages/custom') || href.includes('/pages/dealer')) return true;
    if (el.matches('.pf-button, [data-pf-type="Button"], [data-pf-type="Button"] a') && goodText.some(t => text.includes(t))) return true;
    if (goodText.some(t => text === t || text.includes(t))) return true;

    return false;
  }

  function setPosition(event) {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
    button.classList.add('rvo-real-cta--hover');
  }

  function attach(root = document) {
    root.querySelectorAll(explicitSelector).forEach((el) => {
      if (!isRealCta(el)) return;
      if (el.dataset.rvoRealCtaReady === 'true') return;

      el.dataset.rvoRealCtaReady = 'true';
      el.classList.add('rvo-real-cta');
      el.style.setProperty('--rvo-cta-x', '50%');
      el.style.setProperty('--rvo-cta-y', '50%');

      el.addEventListener('pointerenter', setPosition, { passive: true });
      el.addEventListener('pointermove', setPosition, { passive: true });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('rvo-real-cta--hover');
        el.style.setProperty('--rvo-cta-x', '50%');
        el.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  function start() {
    attach(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) attach(node);
        });
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attach(event.target);
  });
})();


// Extra coverage for PageFly Button2 / pf-button-* elements on the homepage and other PF sections.
(function () {
  const extraSelector = [
    '.__pf a[class*="pf-button"]',
    '.__pf button[class*="pf-button"]',
    '.__pf [data-pf-type^="Button"]',
    'a[href*="/pages/contacts"]',
    'a[href*="/pages/contact-us"]',
    'a[href*="/pages/classic"]',
    'a[href*="/pages/modern"]'
  ].join(',');

  const neverSelector = [
    '.skip-to-content-link',
    '.quantity__button',
    '.drawer__close',
    '.modal__close-button',
    '.search__button',
    '.search-modal__close-button',
    '.slider-button',
    '.share-button__button',
    '.disclosure__button',
    '.localization-form__select',
    '.header__icon',
    '.menu-drawer__close-button',
    '.thumbnail',
    '.facets__summary',
    '.pagination__item',
    'footer a',
    '.footer a',
    '.rvo-footer a',
    '.rvo-footer-static a',
    '[class*="footer"] a'
  ].join(',');

  const goodText = [
    'contact us',
    '+explore',
    'explore',
    'read more',
    'classic collection',
    'modern collection',
    'shop now',
    'learn more',
    'dealer'
  ];

  function shouldMark(el) {
    if (!el || el.matches(neverSelector)) return false;
    if (el.closest('header, .header, .header-wrapper')) return false;
    if (el.closest('cart-drawer, cart-items, .cart-drawer, .cart-items, .cart-item, #main-cart-items, .cart__items')) return false;
    if (el.closest('.product-grid, .card-wrapper, .product-card-wrapper, .card__heading, .related-products, .template-search .card, .collection .card')) return false;
    if (el.closest('footer, .footer, .rvo-footer, .rvo-footer-static, [class*="footer"]')) return false;
    const text = (el.textContent || el.value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const href = ((el.getAttribute && el.getAttribute('href')) || '').toLowerCase();
    if (goodText.some(t => text.includes(t))) return true;
    if (href.includes('/pages/contacts') || href.includes('/pages/contact') || href.includes('/pages/classic') || href.includes('/pages/modern') || href.includes('/pages/dealer')) return true;
    if (el.matches('.__pf a[class*="pf-button"], .__pf button[class*="pf-button"], .__pf [data-pf-type^="Button"]')) return true;
    return false;
  }

  function setGlow(event) {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
    el.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
    el.classList.add('rvo-real-cta--hover');
  }

  function attachExtra(root = document) {
    root.querySelectorAll(extraSelector).forEach((el) => {
      if (!shouldMark(el)) return;
      if (el.dataset.rvoPfCtaReady === 'true') return;
      el.dataset.rvoPfCtaReady = 'true';
      el.classList.add('rvo-real-cta');
      el.style.setProperty('--rvo-cta-x', '50%');
      el.style.setProperty('--rvo-cta-y', '50%');
      el.addEventListener('pointerenter', setGlow, { passive: true });
      el.addEventListener('pointermove', setGlow, { passive: true });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('rvo-real-cta--hover');
        el.style.setProperty('--rvo-cta-x', '50%');
        el.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachExtra());
  } else {
    attachExtra();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachExtra(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) attachExtra(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Keep footer links from becoming CTA buttons.
(function () {
  function cleanFooterLinks(root = document) {
    root.querySelectorAll('footer a, .footer a, .rvo-footer a, .rvo-footer-static a, [class*="footer"] a').forEach((link) => {
      link.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');
      link.removeAttribute('data-rvo-real-cta-ready');
      link.removeAttribute('data-rvo-pf-cta-ready');
      link.style.removeProperty('--rvo-cta-x');
      link.style.removeProperty('--rvo-cta-y');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanFooterLinks());
  } else {
    cleanFooterLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    cleanFooterLinks(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanFooterLinks(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Keep header navigation from becoming CTA buttons.
(function () {
  function cleanHeaderLinks(root = document) {
    root.querySelectorAll('header a, .header a, .header-wrapper a, .header__menu-item, .list-menu__item, .menu-drawer__menu-item').forEach((link) => {
      link.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');
      link.removeAttribute('data-rvo-real-cta-ready');
      link.removeAttribute('data-rvo-pf-cta-ready');
      link.style.removeProperty('--rvo-cta-x');
      link.style.removeProperty('--rvo-cta-y');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanHeaderLinks());
  } else {
    cleanHeaderLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    cleanHeaderLinks(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanHeaderLinks(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Collection selector tabs: only the current page's tab should use the green CTA style.
(function () {
  const selector = 'a[href="/pages/classic"], a[href="/pages/modern"]';

  function normalizePath(path) {
    return (path || '').replace(/\/$/, '') || '/';
  }

  function applyCollectionTabs(root = document) {
    const current = normalizePath(window.location.pathname);

    root.querySelectorAll(selector).forEach((link) => {
      if (!link.closest('.__pf')) return;

      const href = normalizePath(link.getAttribute('href'));
      const isCollectionTab = /^(CLASSIC|MODERN)$/i.test((link.textContent || '').trim()) ||
                              link.closest('[data-section-id]') !== null;

      if (!isCollectionTab) return;

      link.classList.add('rvo-collection-tab');

      if (href === current) {
        link.classList.add('rvo-collection-tab--active', 'rvo-real-cta');
      } else {
        link.classList.remove('rvo-collection-tab--active', 'rvo-real-cta', 'rvo-real-cta--hover');
        link.removeAttribute('data-rvo-real-cta-ready');
        link.style.removeProperty('--rvo-cta-x');
        link.style.removeProperty('--rvo-cta-y');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyCollectionTabs());
  } else {
    applyCollectionTabs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyCollectionTabs(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) applyCollectionTabs(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Keep product card title/image links from becoming green CTA buttons.
(function () {
  const cardLinkSelector = [
    '.product-grid .card-wrapper a',
    '.product-grid .product-card-wrapper a',
    '.related-products .card-wrapper a',
    '.related-products .product-card-wrapper a',
    '.collection .card-wrapper a',
    '.collection .product-card-wrapper a',
    '.template-search .card-wrapper a',
    '.template-search .product-card-wrapper a',
    '.card__heading a',
    'a.full-unstyled-link'
  ].join(',');

  function cleanProductCardLinks(root = document) {
    root.querySelectorAll(cardLinkSelector).forEach((link) => {
      link.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');
      link.removeAttribute('data-rvo-real-cta-ready');
      link.removeAttribute('data-rvo-pf-cta-ready');
      link.removeAttribute('data-rvo-strong-glow-ready');
      link.removeAttribute('data-rvo-bloom-ready');
      link.style.removeProperty('--rvo-cta-x');
      link.style.removeProperty('--rvo-cta-y');
      link.style.removeProperty('--rvo-button-x');
      link.style.removeProperty('--rvo-button-y');
      link.style.removeProperty('--rvo-button-glow');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanProductCardLinks());
  } else {
    cleanProductCardLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    cleanProductCardLinks(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanProductCardLinks(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Previous custom colour dropdown removed: native select is kept for reliable colour/image syncing.




// Reliable PageFly colour/variant sync for product cards.
// Handles both variant-id dropdowns and colour-name dropdowns.
(function () {
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, 'and')
      .replace(/\bgrey\b/g, 'gray')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function money(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents); } catch (e) {}
    }
    var num = Number(cents || 0) / 100;
    return '$' + num.toFixed(2);
  }

  function getProductBox(el) {
    return el.closest('[data-pf-type="ProductBox"]') || el.closest('.pf-product-form') || el.closest('form');
  }

  function getProductId(select) {
    var box = getProductBox(select);
    return select.getAttribute('data-productid') ||
           select.getAttribute('data-product-id') ||
           (box && (box.getAttribute('data-product-id') || box.getAttribute('data-productid'))) ||
           null;
  }

  function getProduct(select) {
    var id = getProductId(select);
    return id && window.__pageflyProducts ? window.__pageflyProducts[String(id)] : null;
  }

  function findVariant(select) {
    var product = getProduct(select);
    var selectedOption = select.options && select.options[select.selectedIndex];
    var rawValue = String(select.value || '');
    var label = selectedOption ? selectedOption.textContent : rawValue;

    if (!product || !Array.isArray(product.variants)) {
      return /^\d+$/.test(rawValue) ? { id: rawValue } : null;
    }

    var byId = product.variants.find(function (variant) {
      return String(variant.id) === rawValue;
    });
    if (byId) return byId;

    var wanted = normalize(label || rawValue);
    return product.variants.find(function (variant) {
      var values = []
        .concat(variant.options || [])
        .concat([variant.option1, variant.option2, variant.option3, variant.title])
        .filter(Boolean)
        .map(normalize);

      return values.some(function (value) {
        return value === wanted || value.indexOf(wanted) !== -1 || wanted.indexOf(value) !== -1;
      });
    }) || null;
  }

  function getMediaId(variant) {
    if (!variant) return null;
    return (variant.featured_media && variant.featured_media.id) ||
           (variant.featured_image && variant.featured_image.id) ||
           variant.featured_media_id ||
           variant.image_id ||
           null;
  }

  function imageFromMedia(media) {
    if (!media) return null;
    return (media.preview_image && (media.preview_image.src || media.preview_image.url)) ||
           (media.image && (media.image.src || media.image.url)) ||
           media.src ||
           media.url ||
           null;
  }

  function imageFromVariant(product, variant) {
    if (!variant) return null;

    var src = imageFromMedia(variant.featured_media) ||
              imageFromMedia(variant.featured_image) ||
              (variant.featured_image && variant.featured_image.src);

    if (src) return { src: src, mediaId: getMediaId(variant), alt: variant.title || product.title };

    var mediaId = getMediaId(variant);
    if (product && Array.isArray(product.media) && mediaId) {
      var media = product.media.find(function (m) { return String(m.id) === String(mediaId); });
      src = imageFromMedia(media);
      if (src) return { src: src, mediaId: mediaId, alt: media.alt || variant.title || product.title };
    }

    return null;
  }

  function findMediaByColour(product, colourLabel) {
    if (!product || !Array.isArray(product.media)) return null;
    var wanted = normalize(colourLabel);
    if (!wanted) return null;

    var media = product.media.find(function (m) {
      return normalize([m.alt, m.src, imageFromMedia(m)].filter(Boolean).join(' ')).indexOf(wanted) !== -1;
    });

    if (!media) return null;

    return {
      src: imageFromMedia(media),
      mediaId: media.id,
      alt: media.alt || colourLabel || product.title
    };
  }

  function getMainImage(box) {
    if (!box) return null;
    var preferred = Array.from(box.querySelectorAll(
      '.pf-main-media img.variant-image, .pf-slide-main-media img.variant-image, [data-pf-type="MediaMain3"] img, [data-pf-type="ProductMedia3"] img.variant-image'
    ));
    var visible = preferred.find(function (img) {
      return img && img.style && img.style.display !== 'none' && img.getAttribute('src');
    });
    return visible || preferred[0] || box.querySelector('img');
  }

  function applyImage(select, variant) {
    var product = getProduct(select);
    var box = getProductBox(select);
    if (!box) return;

    var selectedOption = select.options && select.options[select.selectedIndex];
    var label = selectedOption ? selectedOption.textContent : select.value;
    var image = imageFromVariant(product, variant) || findMediaByColour(product, label);

    if (!image || !image.src) return;

    var mainImg = getMainImage(box);
    if (!mainImg) return;

    var thumb = image.mediaId ? box.querySelector('[data-img-id="' + image.mediaId + '"] img, img[data-media-id="' + image.mediaId + '"]') : null;

    mainImg.src = image.src;
    mainImg.removeAttribute('srcset');
    if (thumb && thumb.getAttribute('srcset')) {
      // Keep srcset only when it appears to point to the same image file.
      var firstSrcsetUrl = thumb.getAttribute('srcset').split(' ')[0];
      if (firstSrcsetUrl && firstSrcsetUrl.split('?')[0] === image.src.split('?')[0]) {
        mainImg.setAttribute('srcset', thumb.getAttribute('srcset'));
      }
    }

    if (image.alt) mainImg.alt = image.alt;
    if (image.mediaId) {
      mainImg.setAttribute('data-media-id', image.mediaId);
      var mainSlide = mainImg.closest('[data-media-id]');
      if (mainSlide) mainSlide.setAttribute('data-media-id', image.mediaId);
      box.querySelectorAll('.pf-slide-list-media').forEach(function (item) {
        item.classList.toggle('active', String(item.getAttribute('data-img-id')) === String(image.mediaId));
      });
    }
  }

  function updateHiddenId(select, variant) {
    var form = select.closest('form');
    if (!form || !variant || !variant.id) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
  }

  function updatePrice(select, variant) {
    if (!variant || typeof variant.price === 'undefined') return;
    var box = getProductBox(select);
    if (!box) return;

    var priceEls = box.querySelectorAll('[data-product-price="true"], [data-product-type="price"]');
    priceEls.forEach(function (el) {
      el.textContent = money(variant.price);
    });
  }

  function syncSelect(select) {
    if (!select) return;

    select.classList.add('rvo-lg-select-native');
    select.style.pointerEvents = '';
    select.style.opacity = '';
    select.removeAttribute('aria-hidden');

    var variant = findVariant(select);
    updateHiddenId(select, variant);
    updatePrice(select, variant);
    applyImage(select, variant);
  }

  function initSelect(select) {
    if (!select || select.dataset.rvoColourReliableReady === 'true') return;
    select.dataset.rvoColourReliableReady = 'true';

    // Remove fake dropdown pieces from previous versions if they are still in the DOM.
    var wrap = select.closest('.rvo-lg-select-wrap');
    if (wrap) wrap.querySelectorAll('.rvo-lg-select-button, .rvo-lg-select-menu').forEach(function (el) { el.remove(); });

    select.addEventListener('change', function () {
      // Run twice: first immediately for cart ID, then after PageFly replacement code settles.
      syncSelect(select);
      window.requestAnimationFrame(function () { syncSelect(select); });
      setTimeout(function () { syncSelect(select); }, 80);
    });

    syncSelect(select);
  }

  function init(root) {
    (root || document).querySelectorAll('.pf-variant-select, .pf-product-form select, [data-pf-type="ProductVariant2"] select').forEach(initSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) init(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Make contact info clickable if it is rendered as plain text by any static/PageFly section.
(function () {
  const mapsUrl = 'https://www.google.com/maps/place/RVO+Products/@44.2688051,-80.5028411,1013m/data=!3m1!1e3!4m15!1m8!3m7!1s0x882a3e55371b9bcf:0x53a6f1691526d7d4!2s346019+4th+Concession+B,+Flesherton,+ON+N0C+1E0!3b1!8m2!3d44.2688051!4d-80.5002608!16s%2Fg%2F11c2d19smc!3m5!1s0x882a4f115fee8e71:0xb6e459b5b0afc57c!8m2!3d44.2688051!4d-80.5002608!16s%2Fg%2F11k3wrhbqw?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D';
  const phoneUrl = 'tel:15195803457';
  const emailUrl = 'mailto:info@rvoproducts.com';

  function linkContactText(root = document) {
    const containers = root.querySelectorAll('.__pf, .contact, .page-width, main');
    containers.forEach((container) => {
      if (container.dataset.rvoContactLinked === 'true') return;

      container.querySelectorAll('span, p, div').forEach((el) => {
        if (el.closest('a')) return;
        const html = el.innerHTML;

        if (html && html.includes('346019') && html.includes('Flesherton')) {
          el.innerHTML = html
            .replace(/346019 4th Concession B,&nbsp;Flesherton ON, NOC&nbsp;1E0,&nbsp;Canada/g, `<a class="rvo-clickable-contact-link" href="${mapsUrl}" target="_blank" rel="noopener">346019 4th Concession B,&nbsp;Flesherton ON, N0C&nbsp;1E0,&nbsp;Canada</a>`)
            .replace(/346019 4th Concession B, Flesherton ON, NOC 1E0, Canada/g, `<a class="rvo-clickable-contact-link" href="${mapsUrl}" target="_blank" rel="noopener">346019 4th Concession B, Flesherton ON, N0C 1E0, Canada</a>`);
        }

        if (el.childElementCount === 0) {
          const text = el.textContent || '';
          if (text.trim() === '519.580.3457') {
            el.innerHTML = `<a class="rvo-clickable-contact-link" href="${phoneUrl}">519.580.3457</a>`;
          }
          if (text.trim() === 'info@rvoproducts.com') {
            el.innerHTML = `<a class="rvo-clickable-contact-link" href="${emailUrl}">info@rvoproducts.com</a>`;
          }
        }
      });

      container.dataset.rvoContactLinked = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => linkContactText());
  } else {
    linkContactText();
  }

  document.addEventListener('shopify:section:load', function (event) {
    linkContactText(event.target);
  });
})();


// Direct fallback: make RVO phone/email spans clickable if still rendered as plain text.
(function () {
  function makeDirectContactLinks(root = document) {
    root.querySelectorAll('.pf-paragraph-content, p, span, div').forEach((el) => {
      if (el.closest('a')) return;
      const text = (el.textContent || '').trim();

      if (text === '519.580.3457') {
        el.innerHTML = '<a class="rvo-clickable-contact-link" href="tel:15195803457">519.580.3457</a>';
      }

      if (text === 'info@rvoproducts.com') {
        el.innerHTML = '<a class="rvo-clickable-contact-link" href="mailto:info@rvoproducts.com">info@rvoproducts.com</a>';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => makeDirectContactLinks());
  } else {
    makeDirectContactLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    makeDirectContactLinks(event.target);
  });
})();


// Colour palette fallback: make exact BLACK label readable on the black tile.
(function () {
  function markBlackPaletteLabel(root = document) {
    root.querySelectorAll('h1,h2,h3,h4,p,span').forEach((el) => {
      if ((el.textContent || '').trim().toLowerCase() === 'black') {
        const paletteSection = el.closest('.__pf');
        if (paletteSection) el.classList.add('rvo-black-palette-label');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => markBlackPaletteLabel());
  } else {
    markBlackPaletteLabel();
  }

  document.addEventListener('shopify:section:load', function (event) {
    markBlackPaletteLabel(event.target);
  });
})();


// Keep cart drawer/cart page product links from becoming green CTA buttons.
(function () {
  function cleanCartLinks(root = document) {
    root.querySelectorAll(
      'cart-drawer a, .cart-drawer a, cart-items a, .cart-items a, .cart-item__name, .cart-item__link'
    ).forEach((link) => {
      link.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');
      link.removeAttribute('data-rvo-real-cta-ready');
      link.removeAttribute('data-rvo-pf-cta-ready');
      link.removeAttribute('data-rvo-strong-glow-ready');
      link.removeAttribute('data-rvo-bloom-ready');
      link.style.removeProperty('--rvo-cta-x');
      link.style.removeProperty('--rvo-cta-y');
      link.style.removeProperty('--rvo-button-x');
      link.style.removeProperty('--rvo-button-y');
      link.style.removeProperty('--rvo-button-glow');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanCartLinks());
  } else {
    cleanCartLinks();
  }

  document.addEventListener('cart:updated', () => cleanCartLinks());
  document.addEventListener('rvo:item-added', () => setTimeout(() => cleanCartLinks(), 100));
  document.addEventListener('shopify:section:load', function (event) {
    cleanCartLinks(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanCartLinks(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Main cart page cleanup: remove CTA styling from cart item links and continue-shopping links.
(function () {
  function cleanMainCartPage(root = document) {
    root.querySelectorAll(
      'cart-items a, #main-cart-items a, .cart__items a, cart-items .button:not(.cart__checkout-button)'
    ).forEach((el) => {
      if (el.classList.contains('cart__checkout-button')) return;
      el.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');
      el.removeAttribute('data-rvo-real-cta-ready');
      el.removeAttribute('data-rvo-pf-cta-ready');
      el.removeAttribute('data-rvo-strong-glow-ready');
      el.removeAttribute('data-rvo-bloom-ready');
      el.style.removeProperty('--rvo-cta-x');
      el.style.removeProperty('--rvo-cta-y');
      el.style.removeProperty('--rvo-button-x');
      el.style.removeProperty('--rvo-button-y');
      el.style.removeProperty('--rvo-button-glow');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanMainCartPage());
  } else {
    cleanMainCartPage();
  }

  document.addEventListener('cart:updated', () => cleanMainCartPage());
  document.addEventListener('rvo:item-added', () => setTimeout(() => cleanMainCartPage(), 100));
  document.addEventListener('shopify:section:load', function (event) {
    cleanMainCartPage(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanMainCartPage(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Cart drawer close fallback and Go to cart hover position.
(function () {
  function closeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
      return;
    }

    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('cart-drawer, .drawer, .cart-drawer').forEach((el) => {
      el.classList.remove('active', 'animate', 'is-open');
      el.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('[data-rvo-cart-drawer-close="true"], .cart-drawer .drawer__close, cart-drawer .drawer__close');
    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();
    closeCartDrawer();
  }, true);

  function attachCartButtonHover(root = document) {
    root.querySelectorAll('.rvo-cart-drawer-view-cart').forEach((button) => {
      if (button.dataset.rvoCartViewReady === 'true') return;
      button.dataset.rvoCartViewReady = 'true';
      button.addEventListener('pointermove', function (event) {
        const rect = button.getBoundingClientRect();
        button.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
        button.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
      }, { passive: true });
      button.addEventListener('pointerleave', function () {
        button.style.setProperty('--rvo-cta-x', '50%');
        button.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachCartButtonHover());
  } else {
    attachCartButtonHover();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) attachCartButtonHover(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Checkout button mouse-position glow for cart page and side cart drawer.
(function () {
  const selector = [
    '.cart__checkout-button',
    'button[name="checkout"]',
    '#checkout',
    '.cart-drawer .cart__checkout-button',
    'cart-drawer .cart__checkout-button'
  ].join(',');

  function setCheckoutGlow(event) {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--rvo-checkout-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--rvo-checkout-y', `${event.clientY - rect.top}px`);
    button.classList.add('rvo-checkout-glow--hover');
  }

  function attachCheckoutGlow(root = document) {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.rvoCheckoutGlowReady === 'true') return;
      button.dataset.rvoCheckoutGlowReady = 'true';
      button.style.setProperty('--rvo-checkout-x', '50%');
      button.style.setProperty('--rvo-checkout-y', '50%');

      button.addEventListener('pointerenter', setCheckoutGlow, { passive: true });
      button.addEventListener('pointermove', setCheckoutGlow, { passive: true });
      button.addEventListener('pointerleave', () => {
        button.classList.remove('rvo-checkout-glow--hover');
        button.style.setProperty('--rvo-checkout-x', '50%');
        button.style.setProperty('--rvo-checkout-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachCheckoutGlow());
  } else {
    attachCheckoutGlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachCheckoutGlow(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) attachCheckoutGlow(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Cart trash/remove buttons: red mouse-position glow.
(function () {
  const selector = [
    '.cart-remove-button .button',
    '.cart-remove-button button',
    '.cart__remove-button',
    '.cart-item__quantity-wrapper cart-remove-button a',
    '.cart-item__quantity-wrapper cart-remove-button button'
  ].join(',');

  function setTrashGlow(event) {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--rvo-trash-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--rvo-trash-y', `${event.clientY - rect.top}px`);
    button.classList.add('rvo-trash-glow--hover');
  }

  function attachTrashGlow(root = document) {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.rvoTrashGlowReady === 'true') return;
      button.dataset.rvoTrashGlowReady = 'true';
      button.style.setProperty('--rvo-trash-x', '50%');
      button.style.setProperty('--rvo-trash-y', '50%');

      button.addEventListener('pointerenter', setTrashGlow, { passive: true });
      button.addEventListener('pointermove', setTrashGlow, { passive: true });
      button.addEventListener('pointerleave', () => {
        button.classList.remove('rvo-trash-glow--hover');
        button.style.setProperty('--rvo-trash-x', '50%');
        button.style.setProperty('--rvo-trash-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachTrashGlow());
  } else {
    attachTrashGlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachTrashGlow(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) attachTrashGlow(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Homepage +Explore buttons: direct mouse-position glow hook.
(function () {
  const selector = '.__pf.__pf_Tcgdlzx- .pf-37_, .__pf.__pf_Tcgdlzx- .pf-45_';

  function setExploreGlow(event) {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--rvo-explore-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--rvo-explore-y', `${event.clientY - rect.top}px`);
    button.classList.add('rvo-explore-glow--hover');
  }

  function attachExploreGlow(root = document) {
    root.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.rvoExploreGlowReady === 'true') return;
      button.dataset.rvoExploreGlowReady = 'true';
      button.style.setProperty('--rvo-explore-x', '50%');
      button.style.setProperty('--rvo-explore-y', '50%');
      button.addEventListener('pointerenter', setExploreGlow, { passive: true });
      button.addEventListener('pointermove', setExploreGlow, { passive: true });
      button.addEventListener('pointerleave', () => {
        button.classList.remove('rvo-explore-glow--hover');
        button.style.setProperty('--rvo-explore-x', '50%');
        button.style.setProperty('--rvo-explore-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachExploreGlow());
  } else {
    attachExploreGlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachExploreGlow(event.target);
  });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) attachExploreGlow(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// PageFly-style carousel fallback: enables prev/next buttons and dots after removing PageFly.
(function () {
  function getPerView(slider) {
    const width = window.innerWidth || document.documentElement.clientWidth;
    const styles = window.getComputedStyle(slider);

    let key = '--ss-lg';
    if (width < 768) key = '--ss-xs';
    else if (width < 1025) key = '--ss-sm';
    else if (width < 1200) key = '--ss-md';

    const raw = parseInt(styles.getPropertyValue(key), 10);
    if (Number.isFinite(raw) && raw > 0) return raw;

    if (width < 768) return 1;
    if (width < 1025) return 2;
    return 3;
  }

  function updateCarousel(slider) {
    const slides = Array.from(slider.children).filter((child) => child.classList.contains('pf-slide'));
    if (!slides.length) return;

    const perView = Math.max(1, Math.min(getPerView(slider), slides.length));
    const maxIndex = Math.max(0, slides.length - perView);
    let index = parseInt(slider.dataset.rvoPfIndex || '0', 10);
    if (!Number.isFinite(index)) index = 0;
    index = Math.max(0, Math.min(index, maxIndex));

    slider.dataset.rvoPfIndex = String(index);
    slider.style.setProperty('--rvo-pf-per-view', String(perView));
    slider.style.setProperty('--rvo-pf-index', String(index));

    slides.forEach((slide, i) => {
      const visible = i >= index && i < index + perView;
      slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
      slide.tabIndex = visible ? 0 : -1;
    });

    const prev = slider.querySelector(':scope > .pf-slider-prev');
    const next = slider.querySelector(':scope > .pf-slider-next');
    if (prev) prev.toggleAttribute('disabled', index <= 0);
    if (next) next.toggleAttribute('disabled', index >= maxIndex);

    let nav = slider.querySelector(':scope > .pf-slider-nav');
    if (nav) {
      const dotCount = maxIndex + 1;
      if (nav.dataset.rvoDotCount !== String(dotCount)) {
        nav.innerHTML = '';
        nav.dataset.rvoDotCount = String(dotCount);
        for (let i = 0; i < dotCount; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rvo-pf-carousel-dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => {
            slider.dataset.rvoPfIndex = String(i);
            updateCarousel(slider);
          });
          nav.appendChild(dot);
        }
      }

      Array.from(nav.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      nav.style.display = dotCount <= 1 ? 'none' : '';
    }
  }

  function moveCarousel(slider, direction) {
    const slides = Array.from(slider.children).filter((child) => child.classList.contains('pf-slide'));
    const perView = Math.max(1, Math.min(getPerView(slider), slides.length));
    const maxIndex = Math.max(0, slides.length - perView);
    let index = parseInt(slider.dataset.rvoPfIndex || '0', 10);
    if (!Number.isFinite(index)) index = 0;

    index += direction;
    if (index < 0) index = maxIndex;
    if (index > maxIndex) index = 0;

    slider.dataset.rvoPfIndex = String(index);
    updateCarousel(slider);
  }

  function setupCarousel(slider) {
    if (!slider || slider.dataset.rvoPfCarouselReady === 'true') {
      if (slider) updateCarousel(slider);
      return;
    }

    const slides = Array.from(slider.children).filter((child) => child.classList.contains('pf-slide'));
    if (!slides.length) return;

    slider.dataset.rvoPfCarouselReady = 'true';
    slider.classList.add('rvo-pf-carousel-ready');
    slider.dataset.rvoPfIndex = slider.dataset.rvoPfIndex || '0';

    const prev = slider.querySelector(':scope > .pf-slider-prev');
    const next = slider.querySelector(':scope > .pf-slider-next');

    if (prev) {
      prev.type = 'button';
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        moveCarousel(slider, -1);
      });
    }

    if (next) {
      next.type = 'button';
      next.addEventListener('click', (event) => {
        event.preventDefault();
        moveCarousel(slider, 1);
      });
    }

    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') moveCarousel(slider, -1);
      if (event.key === 'ArrowRight') moveCarousel(slider, 1);
    });

    updateCarousel(slider);
  }

  function setupAll(root = document) {
    root.querySelectorAll('.pf-slider').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.pf-slider.rvo-pf-carousel-ready').forEach(updateCarousel);
  }, { passive: true });

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) setupAll(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


// Manufacturing Partner spacing fallback: mark the exact heading section and balance top/bottom spacing.
(function () {
  function fixManufacturingSpacing(root = document) {
    root.querySelectorAll('h1,h2,h3,h4').forEach((heading) => {
      const text = (heading.textContent || '').trim().toLowerCase();
      if (text !== 'manufacturing partner' && text !== 'become a manufacturing partner') return;

      const section = heading.closest('[data-pf-type="FlexSection"], section');
      if (!section) return;

      section.classList.add('rvo-manufacturing-heading-section');

      const previous = section.previousElementSibling;
      const next = section.nextElementSibling;

      if (previous) previous.classList.add('rvo-before-manufacturing-heading');
      if (next) next.classList.add('rvo-after-manufacturing-heading');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixManufacturingSpacing());
  } else {
    fixManufacturingSpacing();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixManufacturingSpacing(event.target);
  });
})();


// Mark the Custom Product Manufacturing hero so spacing can be controlled reliably.
(function () {
  function markCustomManufacturingHero(root = document) {
    root.querySelectorAll('h1,h2,h3').forEach((heading) => {
      const text = (heading.textContent || '').trim().toLowerCase();
      if (!text.includes('custom product') || !text.includes('manufacturing')) return;

      const section = heading.closest('[data-pf-type="FlexSection"], section');
      if (!section) return;

      section.classList.add('rvo-custom-manufacturing-hero');

      const links = Array.from(section.querySelectorAll('a'));
      const tabTexts = ['promotional products', 'custom cnc routering', 'product manufacturing'];

      links.forEach((link) => {
        const linkText = (link.textContent || '').trim().toLowerCase();
        if (tabTexts.includes(linkText)) {
          link.classList.add('rvo-custom-tab');
        }
        if (linkText === 'contact us') {
          link.classList.add('rvo-custom-contact');
        }
      });

      const tabLinks = links.filter((link) => link.classList.contains('rvo-custom-tab'));
      if (tabLinks.length) {
        const commonParent = tabLinks[0].parentElement;
        if (commonParent && tabLinks.every((link) => link.parentElement === commonParent)) {
          commonParent.classList.add('rvo-custom-tabs');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => markCustomManufacturingHero());
  } else {
    markCustomManufacturingHero();
  }

  document.addEventListener('shopify:section:load', function (event) {
    markCustomManufacturingHero(event.target);
  });
})();


// Custom Products redesigned page: mouse glow for the new CTA buttons.
(function () {
  const selector = '.rvo-custom-primary, .rvo-custom-secondary';

  function setCustomGlow(event) {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
    el.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
    el.classList.add('rvo-real-cta--hover');
  }

  function attachCustomGlow(root = document) {
    root.querySelectorAll(selector).forEach((el) => {
      if (el.dataset.rvoCustomGlowReady === 'true') return;
      el.dataset.rvoCustomGlowReady = 'true';
      el.style.setProperty('--rvo-cta-x', '50%');
      el.style.setProperty('--rvo-cta-y', '50%');
      el.addEventListener('pointerenter', setCustomGlow, { passive: true });
      el.addEventListener('pointermove', setCustomGlow, { passive: true });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('rvo-real-cta--hover');
        el.style.setProperty('--rvo-cta-x', '50%');
        el.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachCustomGlow());
  } else {
    attachCustomGlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachCustomGlow(event.target);
  });
})();


// RVO homepage makeover: subtle parallax and CTA mouse glow.
(function () {
  function attachHomeCtaGlow(root = document) {
    root.querySelectorAll('.rvo-home-primary, .rvo-home-secondary').forEach((button) => {
      if (button.dataset.rvoHomeGlowReady === 'true') return;
      button.dataset.rvoHomeGlowReady = 'true';
      button.style.setProperty('--rvo-cta-x', '50%');
      button.style.setProperty('--rvo-cta-y', '50%');

      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        button.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
        button.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
        button.classList.add('rvo-real-cta--hover');
      }, { passive: true });

      button.addEventListener('pointerleave', () => {
        button.classList.remove('rvo-real-cta--hover');
        button.style.setProperty('--rvo-cta-x', '50%');
        button.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  function updateParallax() {
    document.querySelectorAll('[data-rvo-parallax]').forEach((wrap) => {
      const rect = wrap.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const progress = (rect.top + rect.height / 2 - viewport / 2) / viewport;
      const y = Math.max(-24, Math.min(24, progress * -28));
      wrap.style.setProperty('--rvo-parallax-y', `${y}px`);

      const main = wrap.querySelector('.rvo-home-hero-card--main');
      const one = wrap.querySelector('.rvo-home-floating-card--one');
      const two = wrap.querySelector('.rvo-home-floating-card--two');

      if (main) main.style.transform = `translate3d(0, ${y}px, 0)`;
      if (one) one.style.transform = `translate3d(0, ${y * -0.55}px, 0) rotate(3deg)`;
      if (two) two.style.transform = `translate3d(0, ${y * 0.65}px, 0)`;
    });
  }

  function init(root = document) {
    attachHomeCtaGlow(root);
    updateParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('scroll', updateParallax, { passive: true });
  window.addEventListener('resize', updateParallax, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();


// Homepage Featured Products: mouse glow for View all products button.
(function () {
  function setViewAllGlow(event) {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--rvo-view-all-x', `${event.clientX - rect.left}px`);
    button.style.setProperty('--rvo-view-all-y', `${event.clientY - rect.top}px`);
    button.classList.add('rvo-view-all-products--hover');
  }

  function attachViewAllGlow(root = document) {
    root.querySelectorAll('.rvo-home-view-all-products').forEach((button) => {
      if (button.dataset.rvoViewAllGlowReady === 'true') return;
      button.dataset.rvoViewAllGlowReady = 'true';
      button.style.setProperty('--rvo-view-all-x', '50%');
      button.style.setProperty('--rvo-view-all-y', '50%');
      button.classList.remove('rvo-real-cta', 'rvo-real-cta--hover');

      button.addEventListener('pointerenter', setViewAllGlow, { passive: true });
      button.addEventListener('pointermove', setViewAllGlow, { passive: true });
      button.addEventListener('pointerleave', () => {
        button.classList.remove('rvo-view-all-products--hover');
        button.style.setProperty('--rvo-view-all-x', '50%');
        button.style.setProperty('--rvo-view-all-y', '50%');
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachViewAllGlow());
  } else {
    attachViewAllGlow();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachViewAllGlow(event.target);
  });
})();


// Homepage Custom Products button fallback: open the custom products page if another script blocks the link.
(function () {
  function attachCustomProductsButton(root = document) {
    root.querySelectorAll('.rvo-home-custom-products-link').forEach((button) => {
      if (button.dataset.rvoCustomProductsButtonReady === 'true') return;
      button.dataset.rvoCustomProductsButtonReady = 'true';
      button.setAttribute('href', '/pages/custom');

      button.addEventListener('click', function (event) {
        if (event.defaultPrevented) {
          event.stopPropagation();
          window.location.href = '/pages/custom';
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => attachCustomProductsButton());
  } else {
    attachCustomProductsButton();
  }

  document.addEventListener('shopify:section:load', function (event) {
    attachCustomProductsButton(event.target);
  });
})();


// Homepage Custom Products button: direct fallback navigation.
(function () {
  function fixCustomProductsLink(root = document) {
    root.querySelectorAll('.rvo-home-custom-products-link').forEach((button) => {
      button.setAttribute('href', '/pages/custom');

      if (button.dataset.rvoCustomProductsLinkReady === 'true') return;
      button.dataset.rvoCustomProductsLinkReady = 'true';

      button.addEventListener('click', function (event) {
        event.stopPropagation();
        window.location.href = '/pages/custom';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixCustomProductsLink());
  } else {
    fixCustomProductsLink();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixCustomProductsLink(event.target);
  });
})();


// Complete native store link safety: make important links work after PageFly removal.
(function () {
  function fixNativeLinks(root = document) {
    const map = [
      ['a[href="/pages/custom"]', '/pages/custom'],
      ['a[href="/pages/custom"]', '/pages/custom'],
      ['a[href="/pages/about"]', '/pages/about'],
      ['a[href="/pages/contact-us"]', '/pages/contacts']
    ];

    map.forEach(([selector, href]) => {
      root.querySelectorAll(selector).forEach((link) => {
        link.setAttribute('href', href);
      });
    });

    root.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'learn about rvo') link.setAttribute('href', '/pages/about');
      if (text === 'contact us' && !link.getAttribute('href')) link.setAttribute('href', '/pages/contacts');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixNativeLinks());
  } else {
    fixNativeLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixNativeLinks(event.target);
  });
})();


// Footer/page link safety for native pages.
(function () {
  function fixFooterPageLinks(root = document) {
    root.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === 'products') link.setAttribute('href', '/pages/products');
      if (text === 'about us') link.setAttribute('href', '/pages/about');
      if (text === 'gallery') link.setAttribute('href', '/pages/gallery');
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'dealers') link.setAttribute('href', '/pages/dealers');
      if (text === 'contacts' || text === 'contact') link.setAttribute('href', '/pages/contacts');
      if (text === 'home') link.setAttribute('href', '/');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixFooterPageLinks());
  } else {
    fixFooterPageLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixFooterPageLinks(event.target);
  });
})();


// Header fix: native shop dropdown toggle and link safety.
(function () {
  function initRvoHeader(root = document) {
    root.querySelectorAll('.rvo-native-header-shop-toggle').forEach((button) => {
      if (button.dataset.rvoHeaderReady === 'true') return;
      button.dataset.rvoHeaderReady = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const wrap = button.closest('.rvo-native-header-shop');
        if (!wrap) return;

        const isOpen = wrap.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('.rvo-native-header-nav a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === 'home') link.setAttribute('href', '/');
      if (text === 'shop' || text === 'all products') link.setAttribute('href', '/pages/products');
      if (text === 'gallery') link.setAttribute('href', '/pages/gallery');
      if (text === 'about us') link.setAttribute('href', '/pages/about');
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'contact') link.setAttribute('href', '/pages/contacts');
      if (text === 'dealers') link.setAttribute('href', '/pages/dealers');
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.rvo-native-header-shop')) {
      document.querySelectorAll('.rvo-native-header-shop.is-open').forEach((wrap) => {
        wrap.classList.remove('is-open');
        const button = wrap.querySelector('.rvo-native-header-shop-toggle');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRvoHeader());
  } else {
    initRvoHeader();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRvoHeader(event.target);
  });
})();


// Final native store link safety.
(function () {
  function fixRvoNativeLinks(root = document) {
    root.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();

      if (text === 'home') link.setAttribute('href', '/');
      if (text === 'products' || text === 'shop' || text === 'all products' || text === 'view all products') link.setAttribute('href', '/pages/products');
      if (text === 'classic collection' || text === 'explore classic') link.setAttribute('href', '/collections/classic');
      if (text === 'modern collection' || text === 'explore modern') link.setAttribute('href', '/collections/modern');
      if (text === 'gallery') link.setAttribute('href', '/pages/gallery');
      if (text === 'about us' || text === 'learn about rvo') link.setAttribute('href', '/pages/about');
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'contact' || text === 'contacts' || text === 'contact us') {
        if (!link.href.includes('mailto:') && !link.href.includes('tel:')) link.setAttribute('href', '/pages/contacts');
      }
      if (text === 'dealers') link.setAttribute('href', '/pages/dealers');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixRvoNativeLinks());
  } else {
    fixRvoNativeLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixRvoNativeLinks(event.target);
  });
})();


// Finished native pages: button glow and link safety.
(function () {
  function attachFinishedPageButtons(root = document) {
    root.querySelectorAll('.rvo-page-primary, .rvo-page-secondary').forEach((button) => {
      if (button.dataset.rvoFinishedButtonReady === 'true') return;
      button.dataset.rvoFinishedButtonReady = 'true';
      button.style.setProperty('--rvo-cta-x', '50%');
      button.style.setProperty('--rvo-cta-y', '50%');

      button.addEventListener('pointermove', function (event) {
        const rect = button.getBoundingClientRect();
        button.style.setProperty('--rvo-cta-x', `${event.clientX - rect.left}px`);
        button.style.setProperty('--rvo-cta-y', `${event.clientY - rect.top}px`);
        button.classList.add('rvo-real-cta--hover');
      }, { passive: true });

      button.addEventListener('pointerleave', function () {
        button.classList.remove('rvo-real-cta--hover');
        button.style.setProperty('--rvo-cta-x', '50%');
        button.style.setProperty('--rvo-cta-y', '50%');
      }, { passive: true });
    });
  }

  function fixFinishedPageLinks(root = document) {
    root.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();

      if (text === 'home') link.setAttribute('href', '/');
      if (text === 'shop' || text === 'products' || text === 'all products' || text === 'view all products') link.setAttribute('href', '/pages/products');
      if (text === 'classic collection' || text === 'explore classic' || text === 'view classic') link.setAttribute('href', '/collections/classic');
      if (text === 'modern collection' || text === 'explore modern' || text === 'view modern') link.setAttribute('href', '/collections/modern');
      if (text === 'gallery') link.setAttribute('href', '/pages/gallery');
      if (text === 'about us' || text === 'learn about rvo') link.setAttribute('href', '/pages/about');
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'dealers') link.setAttribute('href', '/pages/dealers');

      if (text === 'contact' || text === 'contacts' || text === 'contact us' || text === 'start a project' || text === 'become a dealer') {
        const href = link.getAttribute('href') || '';
        if (!href.startsWith('mailto:') && !href.startsWith('tel:') && !href.includes('google.com/maps')) {
          link.setAttribute('href', '/pages/contacts');
        }
      }
    });
  }

  function initFinishedPages(root = document) {
    attachFinishedPageButtons(root);
    fixFinishedPageLinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFinishedPages());
  } else {
    initFinishedPages();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFinishedPages(event.target);
  });
})();


// Premium footer link safety.
(function () {
  function fixPremiumFooterLinks(root = document) {
    root.querySelectorAll('.rvo-premium-footer a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === 'home') link.setAttribute('href', '/');
      if (text === 'products' || text === 'shop products') link.setAttribute('href', '/pages/products');
      if (text === 'classic collection') link.setAttribute('href', '/collections/classic');
      if (text === 'modern collection') link.setAttribute('href', '/collections/modern');
      if (text === 'about us') link.setAttribute('href', '/pages/about');
      if (text === 'gallery') link.setAttribute('href', '/pages/gallery');
      if (text === 'custom products') link.setAttribute('href', '/pages/custom');
      if (text === 'dealers') link.setAttribute('href', '/pages/dealers');
      if (text === 'contacts' || text === 'contact us') {
        const href = link.getAttribute('href') || '';
        if (!href.startsWith('mailto:') && !href.startsWith('tel:') && !href.includes('google.com/maps')) {
          link.setAttribute('href', '/pages/contacts');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixPremiumFooterLinks());
  } else {
    fixPremiumFooterLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixPremiumFooterLinks(event.target);
  });
})();


// Final dynamic form cleanup: hide Shopify/CAPTCHA fields that can appear after typing.
(function () {
  function hideInjectedFormFields(root = document) {
    const forms = root.querySelectorAll
      ? root.querySelectorAll('.rvo-contact-form-card form, .rvo-dealer-form-card form')
      : [];

    forms.forEach((form) => {
      const submit = form.querySelector('button[type="submit"]');

      form.querySelectorAll('input, textarea, select').forEach((field) => {
        const name = (field.getAttribute('name') || '').toLowerCase();
        const type = (field.getAttribute('type') || '').toLowerCase();
        const isAfterSubmit = submit && field.compareDocumentPosition(submit) & Node.DOCUMENT_POSITION_PRECEDING;

        const shouldHide =
          type === 'hidden' ||
          name === 'form_type' ||
          name === 'utf8' ||
          name.includes('captcha') ||
          name.includes('recaptcha') ||
          name.includes('h-captcha') ||
          name.includes('turnstile') ||
          name.includes('g-recaptcha') ||
          (isAfterSubmit && field.tagName.toLowerCase() === 'textarea') ||
          (isAfterSubmit && (name.includes('response') || !name));

        if (shouldHide) {
          field.setAttribute('aria-hidden', 'true');
          field.setAttribute('tabindex', '-1');
          field.style.setProperty('display', 'none', 'important');
          field.style.setProperty('visibility', 'hidden', 'important');
          field.style.setProperty('opacity', '0', 'important');
          field.style.setProperty('position', 'absolute', 'important');
          field.style.setProperty('left', '-99999px', 'important');
          field.style.setProperty('top', '-99999px', 'important');
          field.style.setProperty('width', '0', 'important');
          field.style.setProperty('height', '0', 'important');
          field.style.setProperty('min-height', '0', 'important');
          field.style.setProperty('padding', '0', 'important');
          field.style.setProperty('margin', '0', 'important');
          field.style.setProperty('border', '0', 'important');
          field.style.setProperty('box-shadow', 'none', 'important');
          field.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    });
  }

  function startInjectedFieldObserver() {
    hideInjectedFormFields();

    const observer = new MutationObserver((mutations) => {
      let shouldRun = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const tag = node.tagName ? node.tagName.toLowerCase() : '';
            if (
              tag === 'input' ||
              tag === 'textarea' ||
              tag === 'select' ||
              (node.querySelector && node.querySelector('input, textarea, select'))
            ) {
              shouldRun = true;
            }
          }
        });
      });

      if (shouldRun) {
        window.requestAnimationFrame(() => hideInjectedFormFields());
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener('input', function (event) {
      if (event.target.closest && event.target.closest('.rvo-contact-form-card, .rvo-dealer-form-card')) {
        window.setTimeout(hideInjectedFormFields, 0);
        window.setTimeout(hideInjectedFormFields, 150);
        window.setTimeout(hideInjectedFormFields, 500);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInjectedFieldObserver);
  } else {
    startInjectedFieldObserver();
  }

  document.addEventListener('shopify:section:load', function (event) {
    hideInjectedFormFields(event.target);
  });
})();


// Automatic product/collection mode link safety.
(function () {
  function fixAutomaticProductLinks(root = document) {
    root.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();

      if (text === 'all products' || text === 'view all products' || text === 'products' || text === 'shop products') {
        link.setAttribute('href', '/pages/products');
      }

      if (text === 'classic collection' || text === 'explore classic' || text === 'view classic') {
        link.setAttribute('href', '/collections/classic');
      }

      if (text === 'modern collection' || text === 'explore modern' || text === 'view modern') {
        link.setAttribute('href', '/collections/modern');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fixAutomaticProductLinks());
  } else {
    fixAutomaticProductLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixAutomaticProductLinks(event.target);
  });
})();

// Review widget polish helper.
(function () {
  const WIDGET_SELECTORS = [
    '.jdgm-widget',
    '#shopify-product-reviews',
    '.spr-container',
    '.opinew-widget-app',
    '.ryviu-widget',
    '.stamped-main-widget',
    '.ez-amazon-reviews-importer',
    '.ez-amazon-review-importer',
    '[class*="ez-amazon-review"]',
    '[class*="ez-amazon-reviews"]',
    '[id*="ez-amazon-review"]',
    '[class*="ezair"]',
    '[class*="amazon-review"]',
    '[class*="amazon-reviews"]',
    '[class*="fera-"][class*="widget"]',
    '[id*="fera-"]',
    '[class*="review-widget"]',
    '[class*="reviews-widget"]'
  ].join(', ');

  function decorateReviewWidget(root = document) {
    root.querySelectorAll(WIDGET_SELECTORS).forEach((widget) => {
      if (widget.classList.contains('rvo-review-skin')) return;
      widget.classList.add('rvo-review-skin');
    });

    root.querySelectorAll('h1, h2, h3, h4').forEach((heading) => {
      const text = (heading.textContent || '').trim().toLowerCase();
      if (!text || !text.includes('customer reviews')) return;
      const wrapper = heading.closest('.shopify-app-block, .shopify-section, section, .page-width, div');
      if (!wrapper) return;
      const hasReviewSignals = wrapper.querySelector(WIDGET_SELECTORS) || wrapper.querySelector('[class*="review"], [class*="rating"]');
      if (hasReviewSignals) wrapper.classList.add('rvo-review-skin');
    });
  }

  function initReviewWidgetPolish() {
    decorateReviewWidget();

    const observer = new MutationObserver((mutations) => {
      let shouldDecorate = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches(WIDGET_SELECTORS)) ||
            (node.querySelector && (node.querySelector(WIDGET_SELECTORS) || node.querySelector('[class*="review"], [class*="rating"]')))
          ) {
            shouldDecorate = true;
            break;
          }
        }
        if (shouldDecorate) break;
      }

      if (shouldDecorate) {
        window.requestAnimationFrame(() => decorateReviewWidget());
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewWidgetPolish);
  } else {
    initReviewWidgetPolish();
  }

  document.addEventListener('shopify:section:load', function (event) {
    decorateReviewWidget(event.target);
  });
})();


// Header dropdown hover support for desktop - stronger fixed version.
(function () {
  const MENU_SELECTOR = '.header__inline-menu header-menu > details';
  let lastPointer = { x: -9999, y: -9999 };

  function canUseHover() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  function pointInsideRect(x, y, rect, pad = 0) {
    return x >= rect.left - pad && x <= rect.right + pad && y >= rect.top - pad && y <= rect.bottom + pad;
  }

  function isPointerInsideMenuZone(details) {
    if (!details || !canUseHover()) return false;
    const summary = details.querySelector('summary');
    const submenu = details.querySelector('.header__submenu, .mega-menu__content');
    const x = lastPointer.x;
    const y = lastPointer.y;

    if (pointInsideRect(x, y, details.getBoundingClientRect(), 10)) return true;
    if (summary && pointInsideRect(x, y, summary.getBoundingClientRect(), 18)) return true;
    if (submenu && pointInsideRect(x, y, submenu.getBoundingClientRect(), 20)) return true;

    if (summary && submenu) {
      const s = summary.getBoundingClientRect();
      const m = submenu.getBoundingClientRect();
      const bridge = {
        left: Math.min(s.left, m.left) - 28,
        right: Math.max(s.right, m.right) + 28,
        top: Math.min(s.bottom, m.top) - 8,
        bottom: Math.max(s.bottom, m.top) + 36
      };
      if (pointInsideRect(x, y, bridge, 0)) return true;
    }

    return false;
  }

  function setMenuOpen(details, shouldOpen) {
    const summary = details.querySelector('summary');
    if (shouldOpen) {
      details.setAttribute('open', '');
      details.classList.add('rvo-hover-open');
      details.dataset.rvoHoverState = 'open';
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      details.classList.remove('rvo-hover-open');
      details.dataset.rvoHoverState = 'closed';
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function initHeaderHoverDropdowns(root = document) {
    if (!canUseHover()) return;

    const allMenus = Array.from(document.querySelectorAll(MENU_SELECTOR));
    const rootMenus = Array.from(root.querySelectorAll ? root.querySelectorAll(MENU_SELECTOR) : []);
    const menus = rootMenus.length ? rootMenus : allMenus;

    menus.forEach((details) => {
      if (details.dataset.rvoHoverDropdownV2 === 'true') return;
      details.dataset.rvoHoverDropdownV2 = 'true';

      let closeTimer = null;
      const summary = details.querySelector('summary');
      const submenu = details.querySelector('.header__submenu, .mega-menu__content');

      function openMenu() {
        if (!canUseHover()) return;
        window.clearTimeout(closeTimer);
        document.querySelectorAll(MENU_SELECTOR).forEach((other) => {
          if (other !== details) setMenuOpen(other, false);
        });
        setMenuOpen(details, true);
      }

      function closeMenuSoon(force = false) {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!force && (isPointerInsideMenuZone(details) || details.contains(document.activeElement))) return;
          setMenuOpen(details, false);
        }, force ? 80 : 700);
      }

      function keepOpenEvent(event) {
        if (!canUseHover()) return;
        if (isPointerInsideMenuZone(details) || details.matches(':hover')) {
          event.stopImmediatePropagation();
          openMenu();
        }
      }

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mousemove', openMenu);
      details.addEventListener('mouseleave', () => closeMenuSoon(false));
      details.addEventListener('focusin', openMenu);

      // Stop Dawn's default focusout handler from closing the menu while the mouse is still over the open zone.
      details.addEventListener('focusout', keepOpenEvent, true);

      details.addEventListener('toggle', () => {
        if (!canUseHover()) return;
        if (!details.hasAttribute('open') && (isPointerInsideMenuZone(details) || details.matches(':hover'))) {
          window.setTimeout(openMenu, 0);
        }
      });

      if (summary) {
        summary.addEventListener('mouseenter', openMenu);
        summary.addEventListener('mousemove', openMenu);
        summary.addEventListener('click', () => {
          window.setTimeout(() => {
            if (details.hasAttribute('open')) setMenuOpen(details, true);
          }, 0);
        });
      }

      if (submenu) {
        submenu.addEventListener('mouseenter', openMenu);
        submenu.addEventListener('mousemove', openMenu);
        submenu.addEventListener('mouseleave', () => closeMenuSoon(false));
      }
    });
  }

  function closeMenusIfPointerIsOutside() {
    if (!canUseHover()) return;
    document.querySelectorAll(MENU_SELECTOR).forEach((details) => {
      if (details.hasAttribute('open') && !isPointerInsideMenuZone(details) && !details.contains(document.activeElement)) {
        setMenuOpen(details, false);
      }
    });
  }

  function startHeaderHoverDropdowns() {
    document.addEventListener('mousemove', (event) => {
      lastPointer = { x: event.clientX, y: event.clientY };
    }, { passive: true });

    initHeaderHoverDropdowns();

    document.addEventListener('mousemove', () => {
      window.clearTimeout(window.rvoHeaderDropdownCloseTimer);
      window.rvoHeaderDropdownCloseTimer = window.setTimeout(closeMenusIfPointerIsOutside, 900);
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => {
      initHeaderHoverDropdowns(event.target);
    });

    window.addEventListener('resize', () => {
      initHeaderHoverDropdowns();
      closeMenusIfPointerIsOutside();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        document.querySelectorAll(MENU_SELECTOR).forEach((details) => setMenuOpen(details, false));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHeaderHoverDropdowns);
  } else {
    startHeaderHoverDropdowns();
  }
})();



// Hard fix: keep desktop header dropdown open while hovering Shop or the dropdown.
(function () {
  function isDesktopHover() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  function initRvoHardHoverMenu(root = document) {
    const menuDetails = root.querySelectorAll('.header__inline-menu header-menu > details');

    menuDetails.forEach((details) => {
      if (details.dataset.rvoHardHoverMenu === 'true') return;
      details.dataset.rvoHardHoverMenu = 'true';

      const headerMenu = details.closest('header-menu');
      const summary = details.querySelector('summary');
      let closeTimer = null;

      function closeOtherMenus() {
        document.querySelectorAll('.header__inline-menu header-menu > details').forEach((other) => {
          if (other === details) return;
          other.classList.remove('rvo-menu-held-open');
          other.removeAttribute('open');
          const otherSummary = other.querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        });
      }

      function openMenu() {
        if (!isDesktopHover()) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus();
        details.classList.add('rvo-menu-held-open');
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');

        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) headerWrapper.preventHide = true;
      }

      function closeMenu() {
        details.classList.remove('rvo-menu-held-open');
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');

        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper) headerWrapper.preventHide = false;
      }

      function closeMenuSoon() {
        if (!isDesktopHover()) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (details.matches(':hover') || (headerMenu && headerMenu.matches(':hover')) || details.contains(document.activeElement)) {
            return;
          }
          closeMenu();
        }, 450);
      }

      function cancelClose() {
        window.clearTimeout(closeTimer);
      }

      // Capture these before Dawn's details-disclosure focusout can close the menu while the mouse is still in the menu area.
      details.addEventListener('focusout', (event) => {
        if (!isDesktopHover()) return;
        if (details.matches(':hover') || (headerMenu && headerMenu.matches(':hover'))) {
          event.stopImmediatePropagation();
          openMenu();
        }
      }, true);

      ['mouseenter', 'pointerenter', 'mouseover'].forEach((eventName) => {
        details.addEventListener(eventName, openMenu);
        if (headerMenu) headerMenu.addEventListener(eventName, openMenu);
      });

      ['mouseleave', 'pointerleave'].forEach((eventName) => {
        details.addEventListener(eventName, closeMenuSoon);
        if (headerMenu) headerMenu.addEventListener(eventName, closeMenuSoon);
      });

      details.addEventListener('mousemove', cancelClose);
      if (headerMenu) headerMenu.addEventListener('mousemove', cancelClose);

      if (summary) {
        summary.addEventListener('mouseenter', openMenu);
        summary.addEventListener('focus', openMenu);
        summary.addEventListener('click', (event) => {
          if (!isDesktopHover()) return;
          event.preventDefault();
          event.stopPropagation();
          if (details.hasAttribute('open')) {
            closeMenu();
          } else {
            openMenu();
          }
        }, true);
      }

      const panel = details.querySelector('.header__submenu, .mega-menu__content');
      if (panel) {
        ['mouseenter', 'pointerenter', 'mousemove'].forEach((eventName) => {
          panel.addEventListener(eventName, openMenu);
        });
        ['mouseleave', 'pointerleave'].forEach((eventName) => {
          panel.addEventListener(eventName, closeMenuSoon);
        });
      }
    });
  }

  function startRvoHardHoverMenu() {
    initRvoHardHoverMenu();

    document.addEventListener('shopify:section:load', (event) => {
      initRvoHardHoverMenu(event.target);
    });

    window.addEventListener('resize', () => {
      initRvoHardHoverMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRvoHardHoverMenu);
  } else {
    startRvoHardHoverMenu();
  }
})();


// FINAL: native Shop dropdown hold-open fallback.
(function () {
  function initNativeShopHover(root = document) {
    const shop = root.querySelector('.rvo-native-header-shop');
    if (!shop || shop.dataset.rvoNativeHoverFinal === 'true') return;
    shop.dataset.rvoNativeHoverFinal = 'true';

    const button = shop.querySelector('.rvo-native-header-shop-toggle');
    let timer = null;

    function open() {
      clearTimeout(timer);
      shop.classList.add('is-open');
      if (button) button.setAttribute('aria-expanded', 'true');
    }

    function closeSoon() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (shop.matches(':hover') || shop.contains(document.activeElement)) return;
        shop.classList.remove('is-open');
        if (button) button.setAttribute('aria-expanded', 'false');
      }, 300);
    }

    shop.addEventListener('mouseenter', open);
    shop.addEventListener('mousemove', open);
    shop.addEventListener('mouseleave', closeSoon);
    shop.addEventListener('focusin', open);
    shop.addEventListener('focusout', closeSoon);

    const menu = shop.querySelector('.rvo-native-header-shop-menu');
    if (menu) {
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mousemove', open);
      menu.addEventListener('mouseleave', closeSoon);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initNativeShopHover());
  } else {
    initNativeShopHover();
  }

  document.addEventListener('shopify:section:load', (event) => initNativeShopHover(event.target));
})();
